export default __webpack_public_path__ + "static/media/892.79ab76c4.png";